import refs from '../helpers/refs'

class CProductAccordionSnippet {
  constructor (el) {
    this.$root = el
    this.$refs = refs(this.$root)

    this.init()
  }

  init () {
    // has a slight layout shift
    document.querySelectorAll('details').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (details.open) {
          // Use a delay to scroll after the browser's auto-scroll
          setTimeout(() => {
            // get values from css
            const rootStyles = getComputedStyle(document.documentElement)
            const headerHeight = parseInt(rootStyles.getPropertyValue('--header-height'))
            const remSize = parseFloat(getComputedStyle(document.documentElement).fontSize)
            const targetPosition = details.offsetTop - headerHeight - (5 * remSize) // 30 5rem = 2 for padding, 3 for 1.5 size heading

            // Use instant instead of smooth or auto because we're scrolling after the default behavior has already scrolled
            window.scrollTo({
              top: targetPosition,
              behavior: 'instant'
            })
          }, 40)
        }
      })
    })
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.c-product-accordion-snippet')
    .forEach(el => new CProductAccordionSnippet(el))
})
